module.exports = __webpack_public_path__ + "img/uploadfile.3f8cbbe5.jpg";